import { useEffect, useState } from 'react';
import { getMonthlyTrend } from '../services/publicStatsService';

// Monthly collected/disbursed totals for a school year start year. Pass null to skip.
export function useMonthlyTrend(schoolYear) {
  const [series, setSeries] = useState([]);
  const [loading, setLoading] = useState(schoolYear != null);

  useEffect(() => {
    // Keep the previous series while reloading so charts can dim instead of flashing empty.
    if (schoolYear == null) {
      setSeries([]);
      setLoading(false);
      return undefined;
    }

    let mounted = true;
    setLoading(true);

    getMonthlyTrend(schoolYear)
      .then((data) => {
        if (mounted) setSeries(data);
      })
      .catch(() => {
        if (mounted) setSeries([]);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [schoolYear]);

  return { series, loading };
}
